"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

function useComponentClicked(initialIsVisible, includeNodes, // 컴포넌트에 포함시키는 노드들
callback) {
  var _react_1$useState = react_1.useState(initialIsVisible),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isComponentClicked = _react_1$useState2[0],
      setIsComponentClicked = _react_1$useState2[1];

  var ref = react_1.useRef(null);
  var handleClickOutside = react_1.useCallback(function (event) {
    if (event.type === 'touchstart') {
      // https://developer.mozilla.org/en-US/docs/Web/API/Touch_events/Supporting_both_TouchEvent_and_MouseEvent
      event.preventDefault();
    }

    if (ref.current && !ref.current.contains(event.target) && (includeNodes || []).every(function (element) {
      return element.current !== event.target;
    })) {
      setIsComponentClicked(false);
      callback === null || callback === void 0 ? void 0 : callback(event);
    }
  }, [callback, includeNodes]);
  react_1.useEffect(function () {
    if (initialIsVisible) {
      document.addEventListener('touchstart', handleClickOutside, true);
      document.addEventListener('click', handleClickOutside, true);
    } else {
      document.removeEventListener('touchstart', handleClickOutside, true);
      document.removeEventListener('click', handleClickOutside, true);
    }

    return function () {
      document.removeEventListener('touchstart', handleClickOutside, true);
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [initialIsVisible, handleClickOutside]);
  return {
    ref: ref,
    isComponentClicked: isComponentClicked,
    setIsComponentClicked: setIsComponentClicked
  };
}

exports.default = useComponentClicked;